import templateUrl from "emun.cart/cart-item-quick-view-info.htm";

export default () => ({
  templateUrl
});
